import { render } from "./goaltype-modal.vue?vue&type=template&id=a772c0ea"
import script from "./goaltype-modal.vue?vue&type=script&lang=js"
export * from "./goaltype-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__